import React, {lazy, useEffect, useState} from 'react';
import {Navigate, Route, Routes, useLocation} from 'react-router-dom';
import {LOGIN_ROUTE, RESTORE_PASSWORD, SECTION_ROUTE, system, USER_ACTIVATION} from './services/objects';
import {SnackbarObject} from 'services/snackbar/types';
import Snackbar from 'components/notifications/Snackbar';
import useHistory from 'components/useHistory';
import {Spinner} from './components/spinner';

const SignUser = lazy(() => import('pages/SignUser'));
const ActivationComponent = lazy(() => import('components/Login/Activation'));

const SaveReturnUrl = () => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    localStorage.setItem(system.ReturnUrl, location.pathname + location.search);
    history.push(LOGIN_ROUTE);
  }, []);

  return null;
};

interface Props {
  userConfig: any;
}

export const UnauthenticatedContent = ({userConfig}: Props) => {
  const [notification, setNotification] = useState<SnackbarObject>();
  const location = useLocation();

  const showNotification = ({msg, type, title}: any) => {
    setNotification({
      message: msg,
      type,
      title,
    });
  };

  const hideNotification = () => setNotification(undefined);

  /**
   * После обновления роутра до версии 6 после # стало обязательно ставить /.
   * У нас раньше в фильтрах было так #filter/... сейчас так не работает.
   * Ссылку исправили, но старые роуты перестали работать. Этот хад для поддержания старых роутов.
   */
  if (location.pathname.match(/^\/?filter\//)) {
    localStorage.setItem(system.ReturnUrl, location.pathname + location.search);
    return <Navigate to={LOGIN_ROUTE} replace />;
  }

  return (
    <>
      <Routes>
        <Route
          path={USER_ACTIVATION}
          element={
            <React.Suspense fallback={<Spinner />}>
              <ActivationComponent showNotification={showNotification} />
            </React.Suspense>
          }
        />
        <Route
          path={RESTORE_PASSWORD}
          element={
            <React.Suspense fallback={<Spinner />}>
              <SignUser userConfig={userConfig} showNotification={showNotification} />
            </React.Suspense>
          }
        />
        <Route
          path={LOGIN_ROUTE}
          element={
            <React.Suspense fallback={<Spinner />}>
              <SignUser userConfig={userConfig} showNotification={showNotification} />
            </React.Suspense>
          }
        />
        <Route path={SECTION_ROUTE + '/*'} element={<SaveReturnUrl />} />
        <Route path={`*`} element={<Navigate to={LOGIN_ROUTE} replace={true} />} />
      </Routes>
      <Snackbar
        title={notification?.title}
        type={notification?.type!}
        message={notification?.message!}
        onClose={hideNotification}
      />
    </>
  );
};
